import { render, staticRenderFns } from "./datacollect-form-2.vue?vue&type=template&id=cb2078ba&scoped=true&"
import script from "./datacollect-form-2.vue?vue&type=script&lang=ts&"
export * from "./datacollect-form-2.vue?vue&type=script&lang=ts&"
import style0 from "./datacollect-form-2.vue?vue&type=style&index=0&id=cb2078ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2078ba",
  null
  
)

export default component.exports